import React, { useState } from 'react';

const PreviousIcon = ({
  width = 16,
  height = 16,
  color = '#7F7182',
  hoverColor = 'var(--ca-theme-palette-colors-controlButtonColor, #4B1C46)',
  className = '',
  ...props
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      {...props}
    >
      <path
        d="M12.9973 2.75731L4.99733 7.42398C4.89662 7.48267 4.81305 7.56675 4.75497 7.66781C4.69689 7.76888 4.66633 7.88341 4.66633 7.99998C4.66633 8.11655 4.69689 8.23108 4.75497 8.33215C4.81305 8.43322 4.89662 8.51729 4.99733 8.57598L12.9973 13.2427C13.0986 13.3018 13.2138 13.3331 13.3311 13.3335C13.4484 13.3339 13.5637 13.3033 13.6654 13.2449C13.7671 13.1865 13.8516 13.1023 13.9104 13.0007C13.9691 12.8992 14 12.784 14 12.6666V3.33331C14 3.21601 13.9691 3.10078 13.9104 2.99924C13.8516 2.89771 13.7671 2.81348 13.6654 2.75505C13.5637 2.69662 13.4484 2.66606 13.3311 2.66645C13.2138 2.66685 13.0986 2.69819 12.9973 2.75731ZM2.66667 2.66665C2.82996 2.66667 2.98756 2.72662 3.10958 2.83512C3.2316 2.94363 3.30956 3.09315 3.32867 3.25531L3.33333 3.33331V12.6666C3.33314 12.8366 3.26808 13 3.15143 13.1236C3.03479 13.2471 2.87536 13.3215 2.70574 13.3314C2.53611 13.3414 2.36908 13.2862 2.23878 13.1771C2.10848 13.0681 2.02474 12.9134 2.00467 12.7446L2 12.6666V3.33331C2 3.1565 2.07024 2.98693 2.19526 2.86191C2.32029 2.73689 2.48986 2.66665 2.66667 2.66665Z"
        fill={isHovered ? hoverColor : color}
      />
    </svg>
  );
};

export default PreviousIcon;
